var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueApexCharts',{attrs:{"type":"pie","height":_vm.height,"options":_vm.chartOptions,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }